module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/no4-934bd53dc492b979553cd49bcf5113e5.png";